import script from "./OrdersNew.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersNew.vue?vue&type=script&setup=true&lang=js"

import "./OrdersNew.vue?vue&type=style&index=0&id=1cd49a90&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cd49a90"]])

export default __exports__